import { pageMeta, site } from "@/content";

type MetaEntry =
  { title: string } | { name: string; content: string } | { property: string; content: string };

export function routeHead(
  route: string,
  overrides?: { title?: string; description?: string; jsonLd?: unknown | unknown[] },
) {
  const p = pageMeta(route);
  const title = overrides?.title ?? p?.title ?? site.brandName;
  const description = overrides?.description ?? p?.description ?? "";
  const domain = (site as { domain?: string }).domain?.replace(/\/$/, "") ?? "";
  const url = domain ? `${domain}${route}` : route;
  const ogImage = domain ? `${domain}/images/og-image.jpg` : "/images/og-image.jpg";
  const meta: MetaEntry[] = [
    { title },
    { name: "description", content: description },
    { property: "og:title", content: title },
    { property: "og:description", content: description },
    { property: "og:type", content: "website" },
    { property: "og:site_name", content: site.brandName },
    { property: "og:url", content: url },
    { property: "og:image", content: ogImage },
    { property: "og:image:width", content: "1200" },
    { property: "og:image:height", content: "630" },
    { property: "og:locale", content: "en_AU" },
    { name: "twitter:card", content: "summary_large_image" },
    { name: "twitter:title", content: title },
    { name: "twitter:description", content: description },
    { name: "twitter:image", content: ogImage },
  ];
  const links = [{ rel: "canonical", href: url }];
  const jsonLdList = overrides?.jsonLd
    ? Array.isArray(overrides.jsonLd)
      ? overrides.jsonLd
      : [overrides.jsonLd]
    : [];
  const scripts = jsonLdList.map((data) => ({
    type: "application/ld+json",
    children: JSON.stringify(data),
  }));
  return { meta, links, scripts };
}
